import { useState } from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "../theme";
import { ChatProvider } from "../contexts/ChatContext";
import MateriomAIContainer from "../components/Containers/MateriomAIContainer";

/**
 * MateriomAI Component
 *
 * The main component for the Materiom AI application.
 * This component is protected by the Authenticated layout and the Protected Route, ensuring only
 * authenticated users can access it. It also manages chat input state and
 * provides the ChatProvider context to the MateriomAIContainer.
 *
 * @returns {JSX.Element} The rendered MateriomAI component.
 */
function MateriomAI() {
  // State for the chat input
  const [chatInput, setChatInput] = useState("");
  return (
    <ThemeProvider theme={theme}>
      <title>Materiom AI</title>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          bgcolor: "#F5F5F5",
          position: "relative",
        }}
      >
        {/* Main Content Area */}
        <Box
          sx={{
            flexGrow: 1,
            height: "100%",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            p: 3,
          }}
        >
          {/* Chat Panel and New Sources Form */}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ChatProvider>
              <MateriomAIContainer input={chatInput} setInput={setChatInput} />
            </ChatProvider>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default MateriomAI;
